<template>
  <div>
    <PreviewLayout :item="item" :loading="loading">
      <div class="p-postEditor__product">
        <div class="p-postEditor__product__main">
          <div class="p-postEditor__product__left">
            <div class="p-postEditor__product__figure">
              <div
                v-if="
                  item.itemableAttributes.images &&
                  item.itemableAttributes.images.length >= 1
                "
                @click.stop
              >
                <v-app class="carousel_product_introduction">
                  <v-carousel
                    hide-delimiters
                    class="carousel_product_introduction"
                  >
                    <v-carousel-item
                      v-for="(image, i) in item.itemableAttributes.images"
                      :key="i"
                    >
                      <img
                        class="product_introduction_image"
                        :src="
                          imageSrc(multipleProductImageUrl(image), 200, 200)
                        "
                      />
                    </v-carousel-item>
                  </v-carousel>
                  <div style="display: inline-block">
                    <img
                      v-for="(image, i) in item.itemableAttributes.images"
                      :key="i"
                      class="product_introduction_image_thumbs"
                      :src="imageSrc(multipleProductImageUrl(image), 200, 200)"
                    />
                  </div>
                </v-app>
              </div>
              <img v-else :src="imageSrc(productImageUrl, 200, 200)" />
            </div>
          </div>
          <div class="p-postEditor__product__right">
            <p>{{ item.itemableAttributes.alternateName }}</p>
            <h3 class="p-postEditor__product__heading">
              {{ item.itemableAttributes.name }}
            </h3>
            <h4 v-if="item.itemableAttributes.price">
              <span class="p-postEditor__product__price"
                >{{ item.itemableAttributes.price }}円</span
              >
              （
              <span v-if="item.itemableAttributes.taxIncluded"> 税込 </span>
              <span v-else> 税抜 </span>
              ・参考価格）
            </h4>
            <v-btn
              v-if="item.itemableAttributes.amazonUrl"
              :href="item.itemableAttributes.amazonUrl"
              target="_blank"
              class="mt-2 mb-1 pa-2"
              tile
              outlined
              small
              min-width="200"
              color="orange darken-2"
            >
              <v-icon left small class="ml-1 mr-2"> mdi-amazon </v-icon>
              Amazonで詳細を見る
            </v-btn>
            <v-btn
              v-if="item.itemableAttributes.rakutenUrl"
              :href="item.itemableAttributes.rakutenUrl"
              target="_blank"
              class="mt-2 mb-1 pa-2"
              tile
              outlined
              small
              min-width="200"
              color="red darken-4"
            >
              <v-icon small class="ml-1 mr-2"></v-icon>
              楽天で詳細を見る
            </v-btn>
            <v-btn
              v-if="item.itemableAttributes.officialUrl"
              :href="item.itemableAttributes.officialUrl"
              target="_blank"
              class="mt-2 my-1 pa-2"
              tile
              outlined
              small
              min-width="200"
              color="primary"
            >
              公式サイトで詳細を見る
            </v-btn>
            <v-btn
              v-if="item.itemableAttributes.otherUrl"
              :href="item.itemableAttributes.otherUrl"
              target="_blank"
              class="mt-2 my-1 pa-2"
              tile
              outlined
              small
              min-width="200"
              color="indigo"
            >
              {{
                item.itemableAttributes.otherUrlSentence || '商品の詳細を見る'
              }}
            </v-btn>
          </div>
        </div>
        <div class="p-postEditor__product__footer">
          <h4 class="p-postEditor__product__intro_heading"></h4>
          <p
            class="p-postEditor__product__introduction"
            style="white-space: pre-line"
            v-html="previewContent(description)"
          ></p>
        </div>
      </div>
    </PreviewLayout>
  </div>
</template>

<script>
import PreviewLayout from './PreviewLayout'
import baseTextlintPreview from '@/mixins/base_textlint_preview'
import imageUtilsMixin from '@/mixins/image_utils'

export default {
  name: 'ProductIntroductionItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview, imageUtilsMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    description: function () {
      return this.item.itemableAttributes.description
    },
    quoteUrl: function () {
      return this.item.itemableAttributes.quoteUrl
    },
    productImageUrl: function () {
      if (this.item.itemableAttributes.productImageDirectUrl) {
        return this.item.itemableAttributes.productImageDirectUrl
      } else {
        return this.item.itemableAttributes.downloadImageUrl
      }
    }
  },
  mounted () {
    this.setLintAction(this.description)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.description)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  }
}
</script>
<style scoped>
.carousel_product_introduction {
  width: 200px;
  height: 185px !important;
  max-height: 185px !important;
}

.product_introduction_image {
  height: 185px;
}

.product_introduction_image_thumbs {
  width: 35px;
  height: 30px;
  margin: 2px 0 2px 0;
  object-fit: contain;
}
</style>
